import { getVideoEmbed } from "@/core/utils";
import { YoutubeImagePreview, YoutubeVideoPreview } from "./YoutubeEmbed";
import { VideoSingularFragment } from "@graphqlTypes";
import BasicEmbedImagePreview from "./BasicEmbed/BasicEmbedImagePreview";
import BasicEmbedVideoPreview from "./BasicEmbed/BasicEmbedVideoPreview";
import { forwardRef } from "react";
import { YTRef } from "./YoutubeEmbed/YoutubeEmbed";

type VideoEmbedProps = Omit<
  VideoSingularFragment,
  "__typename" | "headline" | "videoTitle" | "eyebrow"
> & {
  className?: string;
  playVideoLabel?: string;
  debug?: boolean;
  consentSmall?: boolean;
};

const VideoEmbed = forwardRef<YTRef, VideoEmbedProps>((props, ref) => {
  const videoEmbedData = getVideoEmbed(props);
  const { className, playVideoLabel, debug, consentSmall } = props;
  if (!videoEmbedData) return null;
  // if (debug) {
  //   console.log(videoEmbedData);
  // }
  
  const isYoutube = videoEmbedData.isYoutube;
  const hasVideoPreview = Boolean(videoEmbedData.previewVideoUrl);  
  return (
    <>
      {hasVideoPreview ? (
        isYoutube ? (
          <YoutubeVideoPreview
            className={className}
            ref={ref}
            id={videoEmbedData.videoId}
            thumbnail={videoEmbedData.thumbnail}
            previewUrl={videoEmbedData.previewVideoUrl}
            playVideoLabel={playVideoLabel}
            consentSmall={consentSmall}
          />
        ) : (
          <BasicEmbedVideoPreview
            className={className}
            videoUrl={videoEmbedData.videoUrl}
            ref={ref}
            previewVideoUrl={videoEmbedData.previewVideoUrl}
            thumbnail={videoEmbedData.thumbnail}
            playVideoLabel={playVideoLabel}
          />
        )
      ) : isYoutube ? (
        <YoutubeImagePreview
          className={className}
          ref={ref}
          id={videoEmbedData.videoId}
          thumbnail={videoEmbedData.thumbnail}
          playVideoLabel={playVideoLabel}
          consentSmall={consentSmall}
        />
      ) : (
        <BasicEmbedImagePreview
          className={className}
          ref={ref}
          videoUrl={videoEmbedData.videoUrl}
          thumbnail={videoEmbedData.thumbnail}
          playVideoLabel={playVideoLabel}
        />
      )}
    </>
  );
});

export default VideoEmbed;
